<app-go-back-and-title titulo="Ver Expediente"></app-go-back-and-title>
<ngx-spinner [zIndex]="100" name="spExpediente" bdColor="rgba(255,255,255,0.8)" size="default"
  color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
</ngx-spinner>
<div class="row" *appRoles="['Expedientes.Ver']">
  <div *ngIf="expedienteDto">
    <mat-tab-group [(selectedIndex)]="selectedIndex" (selectedIndexChange)="onTabChange()">
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="tab-label-container">
            <mat-icon class="tab-icon">folder_open</mat-icon>
            <span class="tab-text">Expediente</span>
          </div>
        </ng-template>
        <div class="container-fluid">
          <br>
          <button mat-stroked-button color="primary" [matMenuTriggerFor]="menu" class="app-button-action"
            matTooltip="Acciones">
            <mat-icon>more_vert</mat-icon> Acciones
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="generarCedulaNotificacion(expedienteDto)">
              Generar cedula notificación
            </button>
            <button mat-menu-item [routerLink]="['/expedientes/edit/' + expedienteDto.id]">
              <mat-icon>edit</mat-icon>Editar
            </button>
            <button mat-menu-item (click)="openDialogDelete(expedienteDto)">
              <mat-icon>delete</mat-icon> Eliminar
            </button>
          </mat-menu>
          <br><br>

          <div class="row">
            <div class="col">
              <mat-card appearance="outlined">
                <mat-card-header>
                  <mat-card-title>Caratula del expediente</mat-card-title>
                  <mat-card-subtitle>Detalle de la caratula del expediente</mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                  <div class="property-row">

                    <span class="property-name">IdentificadorUnico:</span>
                    <span class="property-value">{{ expedienteDto.identificadorUnico }}
                    </span>
                    <!-- <button class="property-value" (click)="copiarAlPortapapeles(expedienteDto.identificadorUnico)"
                      matTooltip="Copiar al portapapeles" aria-label="Copiar identificadorUnico al portapapeles">
                      Copiar
                    </button> -->
                  </div>
                  <div class="property-row">
                    <span class="property-name">Demanda:</span>
                    <span class="property-value">{{ expedienteDto.demanda | uppercase }}</span>
                  </div>
                  <div class="property-row">
                    <span class="property-name">Demandado:</span>
                    <span class="property-value">{{ expedienteDto.demandado | uppercase }}</span>
                  </div>
                  <div class="property-row">
                    <span class="property-name">Juzgado:</span>
                    <span class="property-value">{{
                      expedienteDto.organismo == undefined
                      ? ""
                      : (expedienteDto.organismo.nombre | titlecase)
                      }}</span>
                    <!-- <button class="icon-display" mat-icon-button (click)="
                      copiarAlPortapapeles(expedienteDto.organismo.nombre)
                    " matTooltip="Copiar al portapapeles" aria-label="Copiar organismo al portapapeles">
                    <mat-icon>content_copy</mat-icon>
                  </button> -->
                  </div>
                  <div class="property-row">
                    <span class="property-name">Causa:</span>
                    <span class="property-value">{{ expedienteDto.causa | uppercase }}</span>
                  </div>
                  <div class="property-row">
                    <span class="property-name">Numero:</span>
                    <span class="property-value">{{ expedienteDto.numero | uppercase }}</span>
                  </div>

                  <div class="property-row">
                    <span class="property-name">Sufijo:</span>
                    <span class="property-value">{{ expedienteDto.sufijo | uppercase }}</span>
                  </div>
                  <div class="property-row">
                    <span class="property-name">Bis:</span>
                    <span class="property-value">{{ expedienteDto.bis | uppercase }}</span>
                  </div>


                </mat-card-content>
              </mat-card>
            </div>
            <div class="col">
              <app-card-expediente-vinculado [idExpediente]="expedienteDto.id"></app-card-expediente-vinculado>
            </div>
            <div class="col">
              <mat-card appearance="outlined">
                <mat-card-header>
                  <mat-card-title>Estados del expediente</mat-card-title>
                  <mat-card-subtitle>Información extra del expediente</mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                  <div class="property-row">
                    <span class="property-name">Ubicación actual:</span>
                    <span class="property-value">{{ expedienteDto.ubicacion | titlecase }}</span>
                  </div>
                  <div class="property-row">
                    <span class="property-name">Clave:</span>
                    <span class="property-value">{{ expedienteDto.claveExpediente }}</span>
                  </div>
                  <div class="property-row">
                    <span class="property-name">Fecha ingreso MEU:</span>
                    <span class="property-value">{{
                      expedienteDto.fechaIngresoMEU | date : "short"
                      }}</span>
                  </div>
                  <div class="property-row">
                    <span class="property-name">Monto demanda:</span>
                    <span class="property-value">{{ expedienteDto.montoDemanda | currency }}</span>
                  </div>

                  <div class="property-row">
                    <span class="property-name">Tipo expediente:</span>
                    <span class="property-value">{{
                      expedienteDto.tipoExpediente == undefined
                      ? ""
                      : (expedienteDto.tipoExpediente.descripcion | uppercase)
                      }}</span>
                  </div>
                  <div class="property-row">
                    <span class="property-name">Estado expediente::</span>
                    <span class="property-value">{{
                      expedienteDto.estadoExpediente == undefined
                      ? ""
                      : (expedienteDto.estadoExpediente.descripcion | uppercase)
                      }}</span>
                  </div>
                  <div class="property-row">
                    <span class="property-name">Estado expediente perito::</span>
                    <span class="property-value">{{
                      expedienteDto.estadoExpedientePerito == undefined
                      ? ""
                      : (expedienteDto.estadoExpedientePerito.descripcion
                      | uppercase)
                      }}</span>
                  </div>

                </mat-card-content>
              </mat-card>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <mat-card appearance="outlined">
                <mat-card-header>
                  <mat-card-title>Descripción general del expediente</mat-card-title>
                  <mat-card-subtitle>Pequeña descripción que detalle el expediente</mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                  <span><strong>Descripción:</strong></span>
                  <span>{{ expedienteDto.descripcion }}</span>
                </mat-card-content>
              </mat-card>
            </div>
            <div class="col">
              <mat-card appearance="outlined">
                <mat-card-header>
                  <mat-card-title>Auditoria Expediente</mat-card-title>
                  <mat-card-subtitle>Trazabilidad y historial de cambios</mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>

                  <div class="property-row">
                    <span class="property-name">Fecha Alta:</span>
                    <span class="property-value">{{ expedienteDto.fechaAlta | date : "short" }}</span>
                  </div>
                  <div class="property-row">
                    <span class="property-name">Ultima modificación:</span>
                    <span class="property-value">{{
                      expedienteDto.fechaModificacion | date : "short"
                      }}</span>
                  </div>
                </mat-card-content>
                <mat-card-actions>
                  <button mat-button color="accent" (click)="verHistorialExpediente(expedienteDto)">Historial de
                    Acciones</button>
                </mat-card-actions>
              </mat-card>
            </div>
          </div>
        </div>
      </mat-tab>

      <!-- Agenda -->
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="tab-label-container">
            <mat-icon class="tab-icon">event</mat-icon>
            <span class="tab-text">Agenda</span>
          </div>
        </ng-template>


        <div class="container-fluid">
          <br>
          <app-general-calendar [idExpediente]="expedienteDto.id"></app-general-calendar>
        </div>
      </mat-tab>

      <!-- Movimientos -->
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="tab-label-container">
            <mat-icon class="tab-icon">swap_horiz</mat-icon>
            <span class="tab-text">Movimientos</span>
          </div>
        </ng-template>

        <div class="container-fluid">
          <br>
          <app-list-movimiento-expediente [idExpediente]="expedienteDto.id"></app-list-movimiento-expediente>
        </div>
      </mat-tab>

      <!-- Registros Contable -->
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="tab-label-container">
            <mat-icon class="tab-icon">request_quote</mat-icon>
            <span class="tab-text">Registros contable</span>
          </div>
        </ng-template>
        <div class="container-fluid">
          <br>
          <app-list-registro-contable [idExpediente]="expedienteDto.id"></app-list-registro-contable>
        </div>
      </mat-tab>

      <!-- Partes -->
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="tab-label-container">
            <mat-icon class="tab-icon">groups</mat-icon>
            <span class="tab-text">Partes</span>
          </div>
        </ng-template>
        <div class="container-fluid">
          <br>
          <app-form-expediente-partes></app-form-expediente-partes>
        </div>
      </mat-tab>

      <!-- Notas -->
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="tab-label-container">
            <mat-icon class="tab-icon">note_alt</mat-icon>
            <span class="tab-text">Notas</span>
          </div>
        </ng-template>
        <div class="container-fluid">
          <br>
          <app-list-expediente-nota [idExpediente]="expedienteDto.id"
            *appRoles="['ExpedientesNotas.Listar']"></app-list-expediente-nota>
        </div>
      </mat-tab>
      <!-- Tareas -->
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="tab-label-container">
            <mat-icon class="tab-icon">task</mat-icon>
            <span class="tab-text">Tareas</span>
          </div>
        </ng-template>
        <div class="container-fluid">
          <br>
          <app-list-tarea [idExpediente]="expedienteDto.id" *appRoles="['Tareas.Listar']"></app-list-tarea>
        </div>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <div class="tab-label-container">
            <mat-icon class="tab-icon">gavel</mat-icon>
            <span class="tab-text">Pruebas</span>
          </div>
        </ng-template>
        <div class="container-fluid">
          <br>
          <app-pruebas-expediente [idExpediente]="expedienteDto.id"></app-pruebas-expediente>
        </div>

      </mat-tab>

      <mat-tab *appRoles="['Audiencias.Listar']">
        <ng-template mat-tab-label>
          <div class="tab-label-container">
            <mat-icon class="tab-icon">record_voice_over</mat-icon>
            <span class="tab-text">Audiencias</span>
          </div>
        </ng-template>
        <div class="container-fluid">
          <br>
          <app-list-audiencia [idExpediente]="expedienteDto.id" *appRoles="['Audiencias.Listar']"></app-list-audiencia>
        </div>

      </mat-tab>
    </mat-tab-group>
  </div>
</div>
